import { motion, useReducedMotion } from "framer-motion";
import { fadeUp } from "@/lib/animations";

export default function AnimatedSection({
  children,
  className = "",
  as = "section",
  testId,
}) {
  const reduceMotion = useReducedMotion();
  const MotionTag = motion[as] || motion.section;

  if (reduceMotion) {
    return (
      <MotionTag className={className} data-testid={testId}>
        {children}
      </MotionTag>
    );
  }

  return (
    <MotionTag {...fadeUp} className={className} data-testid={testId}>
      {children}
    </MotionTag>
  );
}
